import { z } from "zod";
import { locales } from "../models.js";
import { priceSchema } from "../schemas.js";

export default {
  params: z.discriminatedUnion("accountType", [
    z.object({
      accountType: z.union([z.literal("bridge"), z.literal("powens"), z.literal("gcl")]),
      accountName: z.string(),
      operatorLanguage: z.enum(locales),

      contactEmail: z.string(),
      contactPhone: z.string().optional(),
      supervisorOrgId: z.string(),
    }),
    z.object({
      accountType: z.literal("swan"),
      accountName: z.string(),
      operatorLanguage: z.enum(locales),

      contactEmail: z.string(),
      contactPhone: z.string().optional(),
      supervisorOrgId: z.string(),

      transferAmountThreshold: z.number().min(0).nullable(),
      useCard: z.boolean().optional(),
      proAccountPrice: priceSchema.optional().nullable(),
      contractTemplateId: z.string().optional().nullable(),
    }),
  ]),
  response: z.string(),
};
